import i18next from 'i18next';
import { DEFAULT_LOCALE, LOCALES, REGION_TAG, type Locale } from './config';

// SEO internacional de uma SPA com URLs partilhados entre idiomas: o idioma é
// escolhido por ?lng= (ver detect.ts), por isso cada variante tem um URL próprio
// e rastreável. Páginas privadas (conta, carteira, consola…) saem do índice.

const PRIVATE = /^\/(conta|bilhetes|carteira|descobrir|welcome|org|hexis|notificacoes|ligacoes|tap|perfil)(\/|$)/;

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', content);
}
function setLink(rel: string, href: string, hreflang?: string) {
  const sel = `link[rel="${rel}"]${hreflang ? `[hreflang="${hreflang}"]` : ':not([hreflang])'}`;
  let el = document.head.querySelector<HTMLLinkElement>(sel);
  if (!el) { el = document.createElement('link'); el.rel = rel; if (hreflang) el.hreflang = hreflang; document.head.appendChild(el); }
  el.href = href;
}

const urlFor = (path: string, lng: Locale) => {
  const u = new URL(path, window.location.origin);
  if (lng !== DEFAULT_LOCALE) u.searchParams.set('lng', lng);
  return u.toString();
};

export function applySeo(lng: Locale, pathname: string) {
  const desc = i18next.t('seo.description');
  setMeta('name', 'description', desc);
  setMeta('property', 'og:description', desc);
  setMeta('property', 'og:locale', REGION_TAG[lng].replace('-', '_'));
  setMeta('property', 'og:title', document.title);
  const isPrivate = PRIVATE.test(pathname);
  setMeta('name', 'robots', isPrivate ? 'noindex,nofollow' : 'index,follow');
  setLink('canonical', urlFor(pathname, lng));
  // hreflang só em páginas públicas indexáveis.
  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((e) => e.remove());
  if (isPrivate) return;
  for (const l of LOCALES) setLink('alternate', urlFor(pathname, l), REGION_TAG[l]);
  setLink('alternate', urlFor(pathname, DEFAULT_LOCALE), 'x-default');
}
